import React, { useEffect, useState } from 'react';
import { Navbar } from './components/Navbar';
import { HeroSection } from './components/HeroSection';
import { WhatMakesUsDifferent } from './components/WhatMakesUsDifferent';
import { UploadBillBanner } from './components/UploadBillBanner';
import { FeaturedServices } from './components/FeaturedServices';
import { ServicesSection } from './components/ServicesSection';
import { PricingSection } from './components/PricingSection';
import { WhyChooseUs } from './components/WhyChooseUs';
import { CTABanner } from './components/CTABanner';
import { Footer } from './components/Footer';
import { AboutPage } from './pages/AboutPage';
import { BusinessInternetPage } from './pages/BusinessInternetPage';
import { EthernetFiberPage } from './pages/EthernetFiberPage';
import { NetworkSecurityPage } from './pages/NetworkSecurityPage';
import { UCaaSPage } from './pages/UCaaSPage';
import { BusinessPhonePage } from './pages/BusinessPhonePage';
import { SuppliersPage } from './pages/SuppliersPage';
import { ContactPage } from './pages/ContactPage';
import { MovingSoonPage } from './pages/MovingSoonPage';
export function App() {
  const [currentPage, setCurrentPage] = useState('home');
  const navigate = (page: string) => {
    setCurrentPage(page);
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };
  return <div className="min-h-screen bg-white font-sans text-slate-900 selection:bg-primary/20 selection:text-primary-dark" data-id="element-0">
      <Navbar onNavigate={navigate} currentPage={currentPage} data-id="element-1" />
      <main data-id="element-2">
        {currentPage === 'home' && <>
            <HeroSection data-id="element-3" />
            <WhatMakesUsDifferent data-id="element-4" />
            <UploadBillBanner data-id="element-5" />
            <FeaturedServices data-id="element-6" />
            <ServicesSection data-id="element-7" />
            <PricingSection data-id="element-8" />
            <WhyChooseUs data-id="element-9" />
            <CTABanner data-id="element-10" />
          </>}
        {currentPage === 'about' && <AboutPage onNavigate={navigate} data-id="element-11" />}
        {currentPage === 'business-internet' && <BusinessInternetPage onNavigate={navigate} data-id="element-12" />}
        {currentPage === 'ethernet-fiber' && <EthernetFiberPage onNavigate={navigate} data-id="element-13" />}
        {currentPage === 'network-security' && <NetworkSecurityPage onNavigate={navigate} data-id="element-14" />}
        {currentPage === 'ucaas' && <UCaaSPage onNavigate={navigate} data-id="element-15" />}
        {currentPage === 'business-phone' && <BusinessPhonePage onNavigate={navigate} data-id="element-16" />}
        {currentPage === 'suppliers' && <SuppliersPage onNavigate={navigate} data-id="element-17" />}
        {currentPage === 'contact' && <ContactPage onNavigate={navigate} data-id="element-18" />}
        {currentPage === 'moving-soon' && <MovingSoonPage onNavigate={navigate} data-id="element-19" />}
      </main>
      <Footer onNavigate={navigate} data-id="element-20" />
    </div>;
}